export default "__VITE_ASSET__CWyplDyZ__"